// ** React Imports
import React from "react";

// ** Custom Components
import BaseIcon from "./BaseIcon";

// ** Config
import { defaultIconProps } from "./types/iconTypes";

// #####################################################

/**
 * Icon Component - Główny komponent do używania ikon w aplikacji
 */
const Icon = ({
	name,
	variant = defaultIconProps.variant,
	size = defaultIconProps.size,
	color = defaultIconProps.color,
	width,
	height,
	customMargin,
	verticalAlign,
	translateY,
	className,
	style,
	onClick,
	"aria-label": ariaLabel,
	"aria-hidden": ariaHidden = defaultIconProps["aria-hidden"],
	focusable = defaultIconProps.focusable,
	transform,
}) => {
	return (
		<BaseIcon
			name={name}
			variant={variant}
			size={size}
			color={color}
			width={width}
			height={height}
			customMargin={customMargin}
			verticalAlign={verticalAlign}
			translateY={translateY}
			className={className}
			style={style}
			onClick={onClick}
			ariaLabel={ariaLabel}
			ariaHidden={ariaHidden}
			focusable={focusable}
			transform={transform}
		/>
	);
};

// #####################################################

Icon.displayName = "Icon";

export default Icon;

// #####################################################
